import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, ListGroup, Card, Button, Form, Spinner, Modal, Alert, Image } from 'react-bootstrap';
import { FaCheckCircle, FaExclamationCircle, FaUserCircle, FaDownload, FaFilePdf, FaEllipsisV, FaCog, FaUsers, FaThLarge } from 'react-icons/fa';
import axios from 'axios';
import './chatStyles.css';
import { FaPlus } from 'react-icons/fa';
import { Navigate, useNavigate, useParams } from 'react-router-dom';

const Enterprise = () => {
  const [tickets, setTickets] = useState([]);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [events, setEvents] = useState([]);
  const [loadingTickets, setLoadingTickets] = useState(true);
  const [loadingEvents, setLoadingEvents] = useState(false);
  const [newEventDesc, setNewEventDesc] = useState('');
  const [sendingEvent, setSendingEvent] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [ticketDesc, setTicketDesc] = useState('');
  const [priority, setPriority] = useState('2');
  const [files, setFiles] = useState(null);
  const [createdTicketId, setCreatedTicketId] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [previewContent, setPreviewContent] = useState(null);
  const chatBodyRef = useRef(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingTicket, setEditingTicket] = useState(null);
  const [newTicketDesc, setNewTicketDesc] = useState('');
  const [newPriority, setNewPriority] = useState('2');
  const [newTSTAT, setNewTSTAT] = useState('1');
  const [filterStatus, setFilterStatus] = useState('9');
  const [updateMessage, setUpdateMessage] = useState('');
  const [customerDetails, setCustomerDetails] = useState({
    id: '',
    name: '',
    photo: ''
  });
  const [showCustomerModal, setShowCustomerModal] = useState(false);
  const [members, setMembers] = useState([]);
  const [loadingMembers, setLoadingMembers] = useState(false);
  const [showMemberModal, setShowMemberModal] = useState(false);
  const [customers, setCustomers] = useState([]); // New state for customers
  const [loadingCustomers, setLoadingCustomers] = useState(false);
  const [showCustomersModal, setShowCustomersModal] = useState(false); // New state for customers modal
  const { id } = useParams();
  const [fetchedCustomerId, setFetchedCustomerId] = useState(id);
  const navigate = useNavigate(); // useNavigate hook'u burada tanımlanıyor


  const fetchData = async () => {
    const storedUser = localStorage.getItem('user');
    const user = storedUser ? JSON.parse(storedUser) : null;

    if (!user || !user.token) {
      console.error("Kullanıcı veya token bilgisi bulunamadı.");
      setLoadingTickets(false);
      return;
    }

    setCurrentUser(user);
    console.log(id);
    const requestBody = {
      token: user.token,
      process: '100019317',
      customer_id: fetchedCustomerId,
      filter_status: filterStatus,
    };

    try {
      const response = await axios.post('https://musteri.guardnet.com.tr/call.php', requestBody);
      console.log(requestBody)
      setTickets(response.data.tickets || []);
      console.log(response.data);
      setCustomerDetails({
        id: response.data.CUSID,
        name: response.data.CUSNAME,
        photo: response.data.CUSNAME_LOGO_PATH || '', // Add fallback for photo if not present
      });
      if(response.data.result == 404) {
        navigate('/errors/404'); // Burada useNavigate fonksiyonu çağrılıyor
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoadingTickets(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, [filterStatus, fetchedCustomerId]);

  useEffect(() => {
    if (chatBodyRef.current) {
      chatBodyRef.current.scrollTop = chatBodyRef.current.scrollHeight;
    }
  }, [events]);
  const handleShowMemberModal = async () => {
    setLoadingMembers(true);
    setShowMemberModal(true);

    const requestBody = {
      token: currentUser?.token,
      process: '100019328',  // Üyeleri çekmek için gerekli olan process kodu
      customer_id: fetchedCustomerId
    };
    console.log(requestBody)
    try {
      const response = await axios.post('https://musteri.guardnet.com.tr/call.php', requestBody);
      console.log(response)
      if (response.data.members) {
        setMembers(response.data.members);
        console.log(response.data.members)
      } else {
        console.error('Üye bilgileri alınamadı:', response.data.message);
      }
    } catch (error) {
      console.error('Üye bilgileri alınırken hata oluştu:', error);
    } finally {
      setLoadingMembers(false);
    }
  };
  const handleCustomerUpdate = async () => {
    setLoading(true);

    const formData = new FormData();
    formData.append('token', currentUser?.token);
    formData.append('process', '100019326'); // Assuming this is the process for updating customer details
    formData.append('id', customerDetails.id);
    formData.append('name', customerDetails.name);

    // If the photo is a File object (e.g., selected from an <input type="file">)
    if (customerDetails.photo instanceof File) {
      formData.append('logo_path', customerDetails.photo);
    } else {
      // If the photo is not a File object (e.g., URL string), append it as a normal field
      formData.append('logo_path', customerDetails.photo);
    }

    try {
      const response = await fetch('https://musteri.guardnet.com.tr/call.php', {
        method: 'POST',
        body: formData, // No need for Content-Type header when using FormData
      });

      const data = await response.json();
      console.log(data);
      if (response.ok) {
        setUpdateMessage('Müşteri bilgileri başarıyla güncellendi');
        setShowCustomerModal(false);
        await fetchData(); // Trigger fetchData after the update

      } else {
        setUpdateMessage('Müşteri bilgileri güncellenemedi');
        throw new Error('Müşteri güncellenemedi');
      }
    } catch (error) {
      console.error('Error updating customer details:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCustomerModalOpen = () => {
    console.log(customerDetails)
    setShowCustomerModal(true);
  };
  const handleCustomerPhotoChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      setCustomerDetails({ ...customerDetails, photo: file });
    }
  };
  const handleFilterChange = (status) => {
    setFilterStatus(status); // Update filterStatus based on user selection
  };


  const handleAddEvent = async (e) => {
    e.preventDefault();
    setSendingEvent(true);

    const requestBody = {
      token: currentUser?.token,
      process: '100019318',
      TICID: selectedTicket?.TICID,
      TDESC: newEventDesc,
    };

    const formData = new FormData();
    Object.keys(requestBody).forEach(key => {
      formData.append(key, requestBody[key]);
    });

    if (files && files.length > 0) {
      try {
        for (let i = 0; i < files.length; i++) {
          const file = files[i];
          formData.append('EVEFILE[]', file);
        }
      } catch (error) {
        console.error('Dosya işleminde hata:', error);
        setSendingEvent(false);
        return;
      }
    }

    try {
      const response = await fetch('https://musteri.guardnet.com.tr/call.php', {
        method: 'POST',
        body: formData,
      });

      const responseText = await response.text();
      const result = JSON.parse(responseText);
      console.log(result)
      if (response.ok && result.success) {
        setNewEventDesc('');
        setFiles(null);
        await fetchTicketEvents(selectedTicket);
        await fetchData();
      } else {
        console.error('Sunucu hatası:', result);
        throw new Error(`Event eklenemedi: ${result.message || 'Bilinmeyen hata'}`);
      }
    } catch (error) {
      console.error('Veri gönderim hatası:', error.message);
    } finally {
      setSendingEvent(false);
    }
  };

  const fetchTicketEvents = async (ticket) => {
    setLoadingEvents(true);
    const requestBody = {
      token: currentUser.token,
      process: '100019320',
      TICID: ticket.TICID,
    };

    try {
      const response = await axios.post('https://musteri.guardnet.com.tr/call.php', requestBody);
      setEvents(response.data.events || []);
      setSelectedTicket(ticket);
    } catch (error) {
      console.error('Error fetching ticket events:', error);
    } finally {
      setLoadingEvents(false);
    }
  };

  const handleCreateTicket = async (e) => {
    e.preventDefault();
    setLoading(true);

    const requestBody = {
      token: currentUser?.token,
      process: '100019314',
      TICID: null,
      CUSID: fetchedCustomerId,
      TDESC: ticketDesc,
      PRIOR: priority,
      TSTAT: '1',
    };

    try {
      const response = await fetch('https://musteri.guardnet.com.tr/call.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      });

      const data = await response.json();
      if (response.ok && data.TICID) {
        setCreatedTicketId(data.TICID);
        setError(null);

        // Yeni ticket'ı ticket listesine ekle
        const newTicket = { TICID: data.TICID, TDESC: ticketDesc, PRIOR: priority, TSTAT: '1' };
        setTickets([...tickets, newTicket]);

        // Yeni oluşturulan ticket'ı seç
        setSelectedTicket(newTicket);

        // Sağ panelde yeni ticket'ın etkin olarak gösterilmesi için olayları getir
        await fetchData();
        await fetchTicketEvents(newTicket);

        // Modalı kapat
        setShowModal(false);

        // Form alanlarını resetleyin
        setCreatedTicketId(null)
        setTicketDesc('');
        setPriority('2');
      } else {
        throw new Error('Ticket oluşturulamadı');
      }
    } catch (err) {
      setError(err.message);
      setCreatedTicketId(null);
    } finally {
      setLoading(false);
    }
  };


  const openEditModal = (ticket) => {
    setEditingTicket(ticket);
    setNewTicketDesc(ticket.TDESC);
    setNewPriority(ticket.PRIOR);
    setNewTSTAT(ticket.TSTAT);
    setShowEditModal(true);
  };

  const handleEditTicket = async () => {
    setLoading(true);

    const requestBody = {
      token: currentUser?.token,
      process: '100019324',
      CUSID: fetchedCustomerId,
      TICID: editingTicket.TICID,
      TDESC: newTicketDesc,
      PRIOR: newPriority,
      TSTAT: newTSTAT,
    };
    console.log(requestBody);
    try {
      const response = await fetch('https://musteri.guardnet.com.tr/call.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      });

      const data = await response.json();
      console.log(data);
      if (response.ok) {
        setUpdateMessage('Güncelleme Başarılı');
        setShowEditModal(false);

        // Refetch the ticket list to reflect the changes
        await fetchTicketList();
      } else {
        setUpdateMessage('Güncelleme Başarısız');
        throw new Error('Ticket güncellenemedi');
      }
    } catch (error) {
      console.error('Error updating ticket:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchTicketList = async () => {
    setLoadingTickets(true);

    const requestBody = {
      token: currentUser?.token,
      process: '100019317',
      filter_status: filterStatus, // Add filter_status to the request body
      customer_id: fetchedCustomerId,

    };

    try {
      const response = await axios.post('https://musteri.guardnet.com.tr/call.php', requestBody);
      setTickets(response.data.tickets || []);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoadingTickets(false);
    }
  };

  const getStatusIndicator = (ticket) => {
    if (ticket.TSTAT === '1') {
      // Green light for open tickets
      return <div style={{ width: '12px', height: '12px', borderRadius: '50%', backgroundColor: 'rgb(0, 255, 0)', boxShadow: '0 0 8px rgba(0, 255, 0, 0.7)' }} />;
    }
    // Red light for closed tickets
    return <div style={{ width: '12px', height: '12px', borderRadius: '50%', backgroundColor: 'rgb(255, 0, 0)', boxShadow: '0 0 8px rgba(255, 0, 0, 0.7)' }} />;
  };
  const fetchCustomers = async () => {
    setLoadingCustomers(true);
    try {
      const response = await axios.post('https://musteri.guardnet.com.tr/call.php', {
        token: currentUser.token,
        process: "100019332"
      });
      if (response.data && response.data.customers) {
        setCustomers(response.data.customers);
      } else {
        setCustomers([]);
      }
    } catch (error) {
      setError('Veriler alınırken bir hata oluştu.');
      console.error('Error fetching customers:', error);
    } finally {
      setLoadingCustomers(false);
    }
  };
  const renderAttachmentPreview = (attach) => {
    if (attach.CTYPE === 'png' || attach.CTYPE === 'jpeg') {
      console.log(attach.url)
      return (
        <Image
          src={attach.URL}
          thumbnail
          width={200}
          height={200}
          onClick={() => handlePreview(attach.URL)}
        />
      );
    }

    if (attach.CTYPE === 'video/mp4') {
      return (
        <video
          src={attach.URL}
          controls
          width={100}
          height={100}
          onClick={() => handlePreview(attach.URL)}
        />
      );
    }

    if (attach.CTYPE === 'pdf') {
      return (
        <div style={{ display: 'flex', alignItems: 'right', justifyContent: 'space-between', width: '100%' }}>
          <a href={attach.URL} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: '#000' }}>
            <FaFilePdf size={40} style={{ marginRight: '10px', color: '#e74c3c' }} />
            <span>{attach.FNAME.split('/assets/')[1]}</span>
          </a>
          <Button variant="link" href={attach.URL} download>
            <FaDownload /> İndir
          </Button>
        </div>
      );
    }

    return <p>Bu dosya tipi için önizleme desteklenmiyor.</p>;
  };
  const cardBackgroundColors = [
    'rgba(255, 99, 132, 0.2)',
    'rgba(54, 162, 235, 0.2)',
    'rgba(255, 206, 86, 0.2)',
    'rgba(75, 192, 192, 0.2)',
    'rgba(153, 102, 255, 0.2)',
    'rgba(255, 159, 64, 0.2)',
  ];
  const handlePreview = (url) => {
    setPreviewContent(url);
    setShowPreview(true);
  };
  const handleViewClick = (customerId) => {
    console.log(customers);
    setFetchedCustomerId(customerId)
    setShowCustomersModal(false); // Close the modal after selection
  };
  return (
    <Container fluid className="py-2" style={{ backgroundColor: '#f4f6f9' }}>
      <Row className="justify-content-center">
        <Col md={4} style={{ borderRight: '1px solid rgba(0,0,0,0.1)', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', borderRadius: '10px', height: '80vh', overflow: 'hidden' }}>
          <div className="d-flex justify-content-between align-items-center mb-3" style={{ padding: '5px', borderBottom: '1px solid rgba(0,0,0,0.1)', backgroundColor: '#ffffff', borderRadius: '10px' }}>
            <Col className="d-flex justify-content-center">
              <div style={{ display: 'flex', flexDirection: 'column', marginRight: '5px', borderRadius: '10px', backgroundColor: '#ffffff' }}>
                <Image
                  src={customerDetails.photo}
                  alt="Customer Photo"
                  style={{ height: '80px', width: '100%', objectFit: 'contain', borderRadius: '10px' }}
                />
              </div>
            </Col>
          </div>
          <Col
            md={12}
            className="mb-3 d-flex justify-content-between align-items-center"
            style={{
              padding: '8px',
              backgroundColor: '#f4f6f9',
              borderRadius: '15px',
              boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
            }}
          >
            {/* Left Group: Tümü, Açık, Kapalı */}
            <div className="d-flex flex-wrap align-items-center">
              <Button
                variant={filterStatus === '9' ? 'success' : 'outline-success'}
                className="me-2"
                style={{
                  borderRadius: '20px',
                  padding: '6px 16px',
                  fontWeight: 'bold',
                  fontSize: '0.85rem',
                  boxShadow: '0px 4px 10px rgba(0, 150, 0, 0.2)',
                  border: '2px solid #28a745',
                  background: filterStatus === '9' ? '#28a745' : '#fff',
                  color: filterStatus === '9' ? '#fff' : '#28a745',
                }}
                onClick={() => handleFilterChange('9')}
              >
                Tümü
              </Button>
              <Button
                variant={filterStatus === '1' ? 'info' : 'outline-info'}
                className="me-2"
                style={{
                  borderRadius: '20px',
                  padding: '6px 16px',
                  fontWeight: 'bold',
                  fontSize: '0.85rem',
                  boxShadow: '0px 4px 10px rgba(0, 123, 255, 0.2)',
                  border: '2px solid #17a2b8',
                  background: filterStatus === '1' ? '#17a2b8' : '#fff',
                  color: filterStatus === '1' ? '#fff' : '#17a2b8',
                }}
                onClick={() => handleFilterChange('1')}
              >
                Açık
              </Button>
              <Button
                variant={filterStatus === '0' ? 'danger' : 'outline-danger'}
                style={{
                  borderRadius: '20px',
                  padding: '6px 16px',
                  fontWeight: 'bold',
                  fontSize: '0.85rem',
                  boxShadow: '0px 4px 10px rgba(220, 53, 69, 0.2)',
                  border: '2px solid #dc3545',
                  background: filterStatus === '0' ? '#dc3545' : '#fff',
                  color: filterStatus === '0' ? '#fff' : '#dc3545',
                }}
                onClick={() => handleFilterChange('0')}
              >
                Kapalı
              </Button>
            </div>

            {/* Right Group: New, Settings */}
            <div className="d-flex flex-wrap align-items-center">
              <Button
                variant="primary"
                onClick={() => setShowModal(true)}
                style={{
                  borderRadius: '20px',
                  padding: '6px 16px',
                  fontWeight: 'bold',
                  fontSize: '0.85rem',
                  boxShadow: '0px 4px 10px rgba(0, 123, 255, 0.2)',
                  background: '#007bff',
                  color: '#fff',
                  marginRight: '10px',
                }}
              >
                <FaPlus />
              </Button>
              <Button
                variant="info"
                onClick={handleShowMemberModal}
                style={{
                  borderRadius: '20px',
                  padding: '6px 16px',
                  fontWeight: 'bold',
                  fontSize: '0.85rem',
                  boxShadow: '0px 4px 10px rgba(23, 162, 184, 0.2)',
                  background: '#17a2b8',
                  color: '#fff',
                  marginRight: '10px',

                }}
              >
                <FaUsers />
              </Button>
              {id == '96' && (
              <Button
                variant="secondary"
                onClick={handleCustomerModalOpen}
                style={{
                  borderRadius: '20px',
                  padding: '6px 16px',
                  fontWeight: 'bold',
                  fontSize: '0.85rem',
                  boxShadow: '0px 4px 10px rgba(108, 117, 125, 0.2)',
                  background: '#6c757d',
                  color: '#fff',
                  marginRight: '10px',

                }}
              >
                <FaCog />
              </Button>
              )}
              {id === '96' && (
                <Button
                  variant="primary"
                  onClick={() => {
                    setShowCustomersModal(true);
                    fetchCustomers();
                  }}
                  style={{
                    borderRadius: '20px',
                    padding: '6px 16px',
                    fontWeight: 'bold',
                    fontSize: '0.85rem',
                    boxShadow: '0px 4px 10px rgba(0, 123, 255, 0.2)',
                    background: '#007bff',
                    color: '#fff',
                    marginRight: '10px',
                  }}
                >
                  <FaThLarge />
                </Button>
              )}

            </div>
          </Col>





          {loadingTickets ? (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
              <Spinner animation="border" variant="primary" />
            </div>
          ) : tickets.length > 0 ? (
            <div style={{ height: '75%', overflowY: 'auto' }}>
              <ListGroup variant="flush">
                {tickets.map(ticket => (
                  <ListGroup.Item
                    key={ticket.TICID}
                    action
                    onClick={() => fetchTicketEvents(ticket)}
                    active={selectedTicket && selectedTicket.TICID === ticket.TICID}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      padding: '10px',
                      backgroundColor: selectedTicket && selectedTicket.TICID === ticket.TICID ? '#e9f5ff' : '#ffffff',
                      borderBottom: '1px solid rgba(0,0,0,0.1)',
                    }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      {ticket.TOWNER_IMAGE ? (
                        <Image
                          src={ticket.TOWNER_IMAGE}
                          roundedCircle
                          style={{ width: '30px', height: '30px', marginRight: '10px', objectFit: 'cover' }} // Apply objectFit: 'cover'
                        />
                      ) : (
                        <FaUserCircle size={30} style={{ marginRight: '10px', color: '#007bff' }} />
                      )}
                      <div>
                        <div style={{ fontWeight: 'bold', color: '#007bff' }}>{`#${ticket.TICID} - ${ticket.TDESC}`}</div>
                        <div style={{ fontSize: '0.85rem', color: '#6c757d' }}>{new Date(ticket.ANDAT).toLocaleString()}</div>
                      </div>
                    </div>

                    {/* Container to align the status indicator and ellipsis icon to the right */}
                    <div style={{ display: 'flex', alignItems: 'center', marginLeft: 'auto' }}>
                      {getStatusIndicator(ticket)}
                      <FaEllipsisV onClick={() => openEditModal(ticket)} style={{ cursor: 'pointer', marginLeft: '10px' }} />
                    </div>
                  </ListGroup.Item>
                ))}
              </ListGroup>

            </div>
          ) : (
            <p className="text-center" style={{ color: '#6c757d' }}>Henüz ticket bulunmamaktadır.</p>
          )}
        </Col>

        <Col md={8} className="d-flex flex-column" style={{ height: '80vh', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', borderRadius: '10px', backgroundColor: '#ffffff', padding: '20px' }}>
          {loadingEvents ? (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
              <Spinner animation="border" variant="primary" />
            </div>
          ) : selectedTicket ? (
            <>
              <Card
                className="flex-grow-1 mb-3 chat-card"
                style={{
                  maxHeight: '90%',
                  borderRadius: '10px',
                  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                  position: 'relative',
                  overflow: 'hidden',
                }}
              >
                {/* Container for repeating images with gaps */}
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: 'no-repeat(auto-fill, 150px)', // Adjust size of each image container
                    gridGap: '100px', // Space between images
                    justifyContent: 'center',
                    alignItems: 'center',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 0, // Make sure it stays behind content
                    overflow: 'hidden',

                  }}
                >
                  {/* Example repeated image boxes */}

                </div>

                {/* Overlay effect */}
                <div
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    backdropFilter: 'blur(2px)',
                    zIndex: 1,
                  }}
                />


                <Card.Header
                  className="d-flex justify-content-between align-items-center"
                  style={{
                    borderRadius: '10px 10px 0 0',
                    zIndex: 2,
                    backgroundColor: 'rgba(0, 0, 0, 0.7)',
                    color: '#fff',
                    padding: '10px 20px',
                  }}
                >
                  <div style={{ fontWeight: 'bold', fontSize: '1rem' }}>
                    Ticket #{selectedTicket.TICID} - {selectedTicket.TDESC}
                  </div>
                  <div className="d-flex align-items-center">
                    <FaCog style={{ cursor: 'pointer', fontSize: '1.2rem', marginRight: '10px' }} />
                    <FaEllipsisV style={{ cursor: 'pointer', fontSize: '1.2rem' }} />
                  </div>
                </Card.Header>
                <Card.Body ref={chatBodyRef} className="chat-body" style={{ overflowY: 'auto', maxHeight: '100%', zIndex: 2, }}>
                  {events.map(event => (
                    <div key={event.EVEID}>
                      <div className={`chat-bubble ${event.position === 'R' ? 'chat-bubble-right' : 'chat-bubble-left'}`}>
                        <div className="chat-header" style={{ color: event.member.support_color, display: 'flex', alignItems: 'center' }}>
                          {event.position === 'L' && (
                            event.TOWNER_IMAGE ? (
                              <div>
                                <Image
                                  src={event.TOWNER_IMAGE}
                                  roundedCircle
                                  style={{ width: '30px', height: '30px', marginRight: '10px', objectFit: 'cover' }}
                                />
                                <span>{event.member.uname}</span>
                              </div>
                            ) : (
                              <div>

                                <FaUserCircle size={30} style={{ marginRight: '10px', color: '#007bff' }} />
                                <span>{event.member.uname}</span>
                              </div>
                            )
                          )}


                          {event.position === 'R' && (
                            event.TOWNER_IMAGE ? (
                              <div style={{ width: '100%' }}>
                                <span>{event.member.uname}</span>
                                <Image
                                  src={event.TOWNER_IMAGE}
                                  roundedCircle
                                  style={{ width: '30px', height: '30px', marginLeft: '10px', objectFit: 'cover' }}
                                />
                              </div>
                            ) : (
                              <div style={{ width: '100%' }}>
                                <span>{event.member.uname}</span>
                                <FaUserCircle size={30} style={{ marginLeft: '10px', color: '#007bff' }} />
                              </div>
                            )
                          )}
                        </div>
                        {event.ATTACHES && event.ATTACHES.length > 0 && event.ATTACHES.map(attach => (
                          <div key={attach.ATTID} className="attachment-preview-container">
                            {renderAttachmentPreview(attach)}
                          </div>
                        ))}
                        <p>{event.TDESC}</p>
                        <small>{new Date(event.ANDAT).toLocaleString()}</small>
                      </div>
                    </div>
                  ))}
                </Card.Body>
              </Card>
              <Form className="d-flex" onSubmit={handleAddEvent}>
                <Form.Control
                  type="text"
                  placeholder="Mesajınızı yazın..."
                  value={newEventDesc}
                  onChange={(e) => setNewEventDesc(e.target.value)}
                  disabled={sendingEvent}
                  style={{ borderRadius: '20px' }}
                />
                <Button variant="primary" type="submit" disabled={sendingEvent || !newEventDesc} style={{ marginLeft: '10px', borderRadius: '20px' }}>
                  {sendingEvent ? 'Gönderiliyor...' : 'Gönder'}
                </Button>
                <Form.Control
                  type="file"
                  className="ms-2 form-control-sm"
                  style={{ width: '20%', borderRadius: '20px', marginLeft: '10px' }}
                  onChange={(e) => setFiles(e.target.files)}
                  multiple
                />
              </Form>
            </>
          ) : (
            <p className="text-center" style={{ color: '#6c757d', fontSize: '1.2rem', marginTop: '20%' }}>
              Bir ticket seçin veya yeni bir ticket oluşturun.
            </p>
          )}
        </Col>
      </Row>

      <Modal show={showPreview} onHide={() => setShowPreview(false)} centered size="lg">
        <Modal.Body className="text-center">
          <img src={previewContent} alt="Preview" style={{ maxWidth: '100%', maxHeight: '80vh' }} />
        </Modal.Body>
      </Modal>

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Yeni Ticket Oluştur</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleCreateTicket}>
            <Form.Group controlId="formTicketDesc" className="mb-3">
              <Form.Label>Ticket Konusu</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                placeholder="Açıklama giriniz"
                value={ticketDesc}
                maxLength={32}
                onChange={(e) => setTicketDesc(e.target.value.toUpperCase())}  // Girilen değeri büyük harfe çevir
                required
                style={{ borderRadius: '10px', border: '1px solid #ced4da' }}
              />
            </Form.Group>

            {/* <Form.Group controlId="formPriority" className="mb-4">
              <Form.Label>Öncelik</Form.Label>
              <Form.Select
                value={priority}
                onChange={(e) => setPriority(e.target.value)}
                style={{ borderRadius: '10px', border: '1px solid #ced4da' }}
              >
                <option value="1">Yüksek</option>
                <option value="2">Orta</option>
                <option value="3">Düşük</option>
              </Form.Select>
            </Form.Group> */}

            <Button variant="primary" type="submit" className="w-100" style={{ borderRadius: '10px', padding: '10px' }} disabled={loading}>
              {loading ? <Spinner animation="border" size="sm" /> : 'Ticket Oluştur'}
            </Button>
          </Form>

          {createdTicketId && (
            <Alert variant="success" className="mt-4 d-flex align-items-center" style={{ borderRadius: '10px' }}>
              <FaCheckCircle className="me-2" />
              Ticket başarıyla oluşturuldu! Ticket ID: {createdTicketId}
            </Alert>
          )}

          {error && (
            <Alert variant="danger" className="mt-4 d-flex align-items-center" style={{ borderRadius: '10px' }}>
              <FaExclamationCircle className="me-2" />
              Hata: {error}
            </Alert>
          )}
        </Modal.Body>
      </Modal>
      <Modal show={showCustomerModal} onHide={() => setShowCustomerModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Müşteri Bilgilerini Düzenle</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="formCustomerId" className="mb-3">
              <Form.Label>Müşteri ID</Form.Label>
              <Form.Control
                type="text"
                value={customerDetails.id}
                readOnly
                style={{ borderRadius: '10px' }}
              />
            </Form.Group>

            <Form.Group controlId="formCustomerName" className="mb-3">
              <Form.Label>Müşteri Adı</Form.Label>
              <Form.Control
                type="text"
                value={customerDetails.name}
                onChange={(e) => setCustomerDetails({ ...customerDetails, name: e.target.value })}
                style={{ borderRadius: '10px' }}
              />
            </Form.Group>

            <Form.Group controlId="formCustomerPhoto" className="mb-4">
              <Form.Label>Müşteri Fotoğrafı</Form.Label>
              <Form.Control
                type="file"
                onChange={handleCustomerPhotoChange}
                style={{ borderRadius: '10px' }}
              />
            </Form.Group>

            <Button variant="primary" onClick={handleCustomerUpdate} className="w-100" style={{ borderRadius: '10px' }} disabled={loading}>
              {loading ? <Spinner animation="border" size="sm" /> : 'Güncelle'}
            </Button>

            {updateMessage && (
              <Alert variant={updateMessage.includes('başarıyla') ? 'success' : 'danger'} className="mt-3">
                {updateMessage}
              </Alert>
            )}
          </Form>
        </Modal.Body>
      </Modal>
      <Modal show={showEditModal} onHide={() => setShowEditModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Ticket Düzenle</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="formEditTicketDesc" className="mb-3">
              <Form.Label>Ticket Açıklaması</Form.Label>
              <Form.Control
                type="text"
                value={newTicketDesc}
                onChange={(e) => setNewTicketDesc(e.target.value.toUpperCase())}
                maxLength={32}  // 32 karakter sınırı
                required
                style={{ borderRadius: '10px' }}
              />
            </Form.Group>

            {/* <Form.Group controlId="formEditPriority" className="mb-3">
              <Form.Label>Öncelik</Form.Label>
              <Form.Select
                value={newPriority}
                onChange={(e) => setNewPriority(e.target.value)}
                style={{ borderRadius: '10px' }}
              >
                <option value="1">Yüksek</option>
                <option value="2">Orta</option>
                <option value="3">Düşük</option>
              </Form.Select>
            </Form.Group> */}

            <Form.Group controlId="formEditStatus" className="mb-4">
              <Form.Label>Durum</Form.Label>
              <div>
                <Form.Check
                  inline
                  type="radio"
                  label="Açık"
                  value="1"
                  checked={newTSTAT === '1'}
                  onChange={(e) => setNewTSTAT(e.target.value)}
                />
                <Form.Check
                  inline
                  type="radio"
                  label="Kapalı"
                  value="0"
                  checked={newTSTAT === '0'}
                  onChange={(e) => setNewTSTAT(e.target.value)}
                />
              </div>
            </Form.Group>

            <Button variant="primary" onClick={handleEditTicket} className="w-100" style={{ borderRadius: '10px' }} disabled={loading}>
              {loading ? <Spinner animation="border" size="sm" /> : 'Güncelle'}
            </Button>

            {updateMessage && (
              <Alert variant={updateMessage.includes('Başarılı') ? 'success' : 'danger'} className="mt-3">
                {updateMessage}
              </Alert>
            )}
          </Form>
        </Modal.Body>
      </Modal>
      <Modal show={showMemberModal} onHide={() => setShowMemberModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Members List</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loadingMembers ? (
            <div className="d-flex justify-content-center align-items-center">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : (
            <ListGroup>
              {members.map((member) => (
                <ListGroup.Item key={member.id} className="d-flex align-items-center">
                  <Image
                    src={member.image || <FaUserCircle />}
                    roundedCircle
                    style={{ width: '40px', height: '40px', marginRight: '10px', objectFit: 'cover' }}
                    alt={member.uname}
                  />
                  <div>
                    <div style={{ fontWeight: 'bold' }}>{member.uname}</div>
                    <div style={{ fontSize: '0.85rem', color: '#6c757d' }}>{member.TITLE}</div>
                    <div style={{ fontSize: '0.85rem', color: '#6c757d' }}>{member.customer_id}</div>
                  </div>
                </ListGroup.Item>
              ))}
            </ListGroup>

          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowMemberModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showCustomersModal} onHide={() => setShowCustomersModal(false)} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Müşteri Listesi</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: '500px', overflowY: 'auto' }}>
        {loadingCustomers ? (
            <div className="d-flex justify-content-center align-items-center">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : (
            <Row className="gy-4 mt-1">
              {customers.map((customer, index) => (
                <Col xs={12} md={6} lg={4} key={customer.id}>
                  <Card
                    className="hover-card"
                    style={{
                      borderRadius: '12px',
                      border: 'none',
                      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                      overflow: 'hidden',
                      height: '200px',
                      transition: 'transform 0.3s ease',
                    }}
                  >
                    <div style={{ height: '50%', overflow: 'hidden' }}>
                      <Image
                        src={customer.logo || 'https://via.placeholder.com/150'}
                        style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                        alt={customer.name}
                      />
                    </div>
                    <Card.Body
                      style={{
                        backgroundColor: cardBackgroundColors[index % cardBackgroundColors.length],
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: '10px',
                        height: '70%'
                      }}
                    >
                      <h6>{customer.name}</h6>
                      <p>{customer.open_ticket} açık talep</p>
                      <Button
                        variant="primary"
                        size="sm"
                        onClick={() => handleViewClick(customer.id)}
                      >
                        Görüntüle
                      </Button>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          )}
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default Enterprise;

